import React, { Component } from 'react';
import $ from 'jquery';
import { ApiClient } from "../libs/apiClient";
import { SERVICE_RESPONSE } from '../libs/utils/Const';
import config from "../config";
import CutTransferUsersModal from './CutTransferUsersModal';
let apiClient = ApiClient.getInstance();

const headers = [
    { key: 'idSale', title: 'ID' },
    { key: 'docDate', title: 'Fecha' },
    // { key: 'docEntry', title: 'DocEntry' },
    { key: 'docNum', title: 'Documento' },
    { key: 'docObjectType', title: 'No. TipoDoc' },
    { key: 'folio', title: 'Folio' },
    { key: 'CashTotal', title: 'Total' },
];

class CutTransferModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            UsrOri: '',
            UsrDes: '',
            UsrOriName: '',
            UsrDesName: '',
            ShiftType: '',
            ReassignTo: '',
            CreateDate: '',
            AcceptDate: '',
            Status: 'P',
            IdOTRC: '',
            operations: [],
            idWorkShift: null,
            showCutTransferUsersModal: false,
            showConfirmModal: false,
            confirmText: '',
            isDisabledTransfer: true,
            isReassigned: false,
            auxDetail: {},
        }
    }

    async componentDidMount() {
        const { user } = this.state;
        const { isDetail = false } = this.props;
        if (!isDetail) {
            this.setState({
                UsrOri: user?.USER_CODE ?? ''
            }, async () => {
                await this.getInfo();
            });
        } else {
            await this.getInfo();
        }
    }

    close = async () => {
        $('#cutTransferModal').modal('hide');
    }

    closeAction = (closeAll = false) => {
        const { cleanData, isDetail } = this.props;
        const { isReassigned } = this.state;
        cleanData(isReassigned ? true : isDetail ? false : closeAll ? true : false);
    };

    getInfo = async () => {
        const { enableSpinner, showAlert, isDetail = false, newOrderModel = {} } = this.props;
        const { UsrOri } = this.state;
        let data = {
            operation: 'getUsers',
        }
        enableSpinner(true);
        let usersRes = await apiClient.cutTransferOperation(data);
        enableSpinner(false);
        if (usersRes?.status !== SERVICE_RESPONSE.SUCCESS) {
            showAlert({ type: "error", message: `${usersRes?.message}` });
            return
        }
        let usersInfo = usersRes?.data ?? [];

        if (!isDetail) {
            usersInfo = usersInfo?.filter(u => u.USER_CODE !== UsrOri) ?? [];
            if (!usersInfo?.length) {
                showAlert({ type: "info", message: `No hay información de usuarios destinos` });
                return
            }

            let operations = [];
            enableSpinner(true);
            const sessionRes = await apiClient.checkWorkSession();
            enableSpinner(false);

            if (sessionRes.status === 1) {
                const idWorkShift = sessionRes?.data?.idSession ?? null
                if (idWorkShift) {
                    enableSpinner(true);
                    const historyRes = await apiClient.showWorkShiftHistory({ idWorkShift });
                    enableSpinner(false);
                    if (historyRes?.status === SERVICE_RESPONSE.SUCCESS) {
                        if (!historyRes?.data?.sessionMovements?.length) {
                            showAlert({ type: "info", message: `No hay información de operaciones para el corte actual` });
                        } else {
                            let cashOperations = historyRes?.data?.sessionMovements?.filter(({ payments = [], VoucherLinked, isForOTRC, U_BaseOperId, CANCELED }) =>
                                payments?.some(({ typeMethod }) => Number(typeMethod) === 0) && // Solo efectivo
                                (VoucherLinked || 'N') === 'N' && // Que no estén ligados a un comprobante
                                (isForOTRC || 'N') === 'N' && // Que no haya sido traspasado a OTRC
                                (CANCELED || 'N') === 'N' && // Que no esté cancelado
                                (!U_BaseOperId || Number(U_BaseOperId ?? 0) === 0) // No proviene de traspaso
                            );

                            if (cashOperations?.length) {
                                operations = cashOperations?.map((operation) => {

                                    const cashTotal = (operation.payments || []).reduce((acc, curr) =>
                                        acc + (Number(curr.typeMethod) === 0 ? (Number(curr.amount) || 0) : 0)
                                        , 0);

                                    return {
                                        idSale: operation.idSale,
                                        docDate: operation.docDate,
                                        docEntry: operation.docEntry,
                                        docNum: operation.docNum,
                                        docObjectType: operation.docObjectType,
                                        folio: operation.folio,
                                        CashTotal: cashTotal,
                                    };
                                });
                            } else {
                                showAlert({ type: "info", message: `No hay información de operaciones disponibles que puedan ser traspasadas` });
                            }
                        }

                        this.setState({ idWorkShift, operations });
                    } else {
                        this.setState({ idWorkShift });
                    }
                }
            }

            this.setState({
                users: usersInfo,
                allUsers: usersInfo ?? [],
            });
        } else { // Asignar detalle
            const { UsrOri = '', UsrDes = '', UsrOriName = '', UsrDesName = '', ShiftType = '', CreateDate = '', AcceptDate = '', Status = 'P', IdOTRC = '', operations } = newOrderModel;
            data = {
                operation: 'getUsers',
                filter: UsrOri
            };

            enableSpinner(true);
            usersRes = await apiClient.cutTransferOperation(data);
            enableSpinner(false);

            if (usersRes?.status !== SERVICE_RESPONSE.SUCCESS) {
                showAlert({ type: "error", message: `${usersRes?.message}` });
                return;
            }
            usersInfo = usersRes?.data ?? [];

            const allUsers = usersInfo?.filter(u => u.USER_CODE !== UsrOri) ?? [];
            if (ShiftType) {
                const expectedSession = ShiftType === 'O' ? 'Y' : 'N';
                usersInfo = allUsers?.filter(u => u.HasOpenSession === expectedSession);
            }

            this.setState({
                users: usersInfo,
                allUsers: allUsers ?? [],
                UsrOri,
                UsrDes,
                ShiftType,
                UsrOriName,
                UsrDesName,
                operations,
                auxDetail: newOrderModel,
                CreateDate,
                AcceptDate,
                Status,
                IdOTRC,
            });
        }
    }

    setKeyValue = (key, value) => {
        if (key === 'ShiftType') {
            $('#cutTransferUsersModal').modal('hide');

            setTimeout(() => {
                this.setState(prevState => {
                    let filteredUsers = prevState.allUsers ?? [];

                    if (value) {
                        const expectedSession = value === 'O' ? 'Y' : 'N';
                        filteredUsers = filteredUsers.filter(
                            u => u.HasOpenSession === expectedSession
                        );
                    }

                    return {
                        showCutTransferUsersModal: false,
                        ShiftType: value,
                        UsrDes: '',
                        users: filteredUsers,
                        isDisabledTransfer: true
                    };
                });
            }, 500);
        } else {
            this.setState({ [key]: value });
        }
    };

    showUsers = () => {
        this.setState({ showCutTransferUsersModal: true }, () => {
            $('#cutTransferUsersModal').modal('show');
        });
    }

    hideUsers = () => {
        $('#cutTransferUsersModal').modal('hide');
        setTimeout(() => {
            this.setState({ showCutTransferUsersModal: false });
        }, 500);
    }

    selectUser = (data) => {
        const { users = [], ShiftType, UsrOri, operations } = this.state;
        if (!users?.length) return;

        const USER_CODE = users?.find(u => u.pk_UserID === data?.pk_UserID)?.USER_CODE ?? '';
        const isDisabledTransfer = !ShiftType || !UsrOri || !USER_CODE || !operations?.length;
        this.setState({ UsrDes: USER_CODE ?? '', isDisabledTransfer }, () => {
            this.hideUsers()
        });
    }

    cutTransferOper = async () => {
        const { enableSpinner, showAlert } = this.props;
        const { UsrOri, UsrDes, ShiftType, operations, isReassigned = false, IdOTRC = '', auxDetail = {} } = this.state;
        let data = {}
        if (!isReassigned) {
            data = {
                operation: 'add',
                UsrOri,
                UsrDes,
                ShiftType,
                operations
            }
        } else {
            data = {
                operation: 'reassign',
                IdOTRC,
                ReassignTo: UsrDes,
                ShiftType
            }

            if (UsrDes === auxDetail?.UsrDes) {
                showAlert({ type: "error", message: `El usuario a reasignar el traspaso del corte no puede ser el mismo`, timeOut: 10000 });
                return
            }
        }
        enableSpinner(true);
        let usersRes = await apiClient.cutTransferOperation(data);
        enableSpinner(false);
        if (usersRes?.status !== SERVICE_RESPONSE.SUCCESS) {
            showAlert({ type: "error", message: `${usersRes?.message}`, timeOut: 10000 });
            return
        } else {
            showAlert({ type: "success", message: `${usersRes?.message}`, timeOut: 10000 });
            this.closeAction(true);
        }
    }

    showConfirmModal = (action = '') => {
        if (!action) return;
        if (action === 1 || action === 2) { // 1: Traspaso, 2: Reasignación
            const confirmText = action === 1 ? '¿Está seguro de realizar el traspaso del corte? Solo se registrarán las operaciones pendientes' : '¿Está seguro de reasignar el traspaso del corte?';
            this.setState({
                showConfirmModal: true,
                confirmText
            }, () => {
                $('#confirmCutTransferModal').modal('show');
            })
        }
    }

    hideConfirmModal = () => {
        $('#confirmCutTransferModal').modal('hide');
        setTimeout(() => {
            this.setState({
                showConfirmModal: false
            });
        }, 500);
    }

    confirmAction = async () => {
        await this.hideConfirmModal()
        this.cutTransferOper();
    }

    U_Status = (value) => {
        const { AcceptDate = '' } = this.state;
        if (value === 'P') return 'Pendiente';
        if (value === 'R') return 'Reasignado';

        if (value === 'C') {
            // Diferenciar Aceptado vs Cerrado
            return AcceptDate ? 'Aceptado'
                : 'Cerrado';
        }
        return '--';
    }

    cancellReassigned = () => {
        const { auxDetail } = this.state;
        const { UsrOri = '', UsrDes = '', UsrOriName = '', UsrDesName = '', ShiftType = '', CreateDate = '', AcceptDate = '', Status = 'P', operations } = auxDetail;

        this.setState({
            UsrOri,
            UsrDes,
            UsrOriName,
            UsrDesName,
            ShiftType,
            operations,
            CreateDate,
            AcceptDate,
            Status,
            isReassigned: false,
            isDisabledTransfer: true
        });
    }

    reassigned = () => {
        const { showAlert } = this.props;
        this.setState({
            UsrDes: '',
            isReassigned: true,
            isDisabledTransfer: true
        }, () => {
            showAlert({ type: "info", message: 'Por favor seleccione el usuario destino al cual se le reasginará el traspaso del corte', timeOut: 10000 });
        }
        )
    }

    render() {
        const { users = [], operations = [], UsrOri = '', UsrDes = '', ShiftType = ''
            , showCutTransferUsersModal = false, showConfirmModal = false, confirmText = ''
            , isDisabledTransfer = true, isReassigned = false, CreateDate = '', AcceptDate = ''
            , Status = 'P', UsrOriName = '', UsrDesName = ''
        } = this.state;
        const { enableSpinner, showAlert, isDetail = false } = this.props;
        const IdOTRC = isDetail && !isReassigned && operations?.[0]?.IdOTRC ? ` #${operations?.[0]?.IdOTRC}` : '';

        return (
            <div>
                {/* 🔹 MODAL PRINCIPAL */}
                <div className="modal fade bd-example-modal-xl modal-open scroll" role="dialog" id="cutTransferModal" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-xl modal-open" role="document" >
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">{`Traspaso del corte${isDetail && !isReassigned ? ` - Detalle${IdOTRC}` : isReassigned ? ` - Reasignación` : ''}`}</h4>
                                <button type="button" className="close" onClick={() => this.closeAction()} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        {/* IZQUIERDA */}
                                        <div className="col-12 col-md-6">

                                            {/* SOLO DETALLE */}
                                            {isDetail && (
                                                <>
                                                    {/* Estatus */}
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text font-weight-bold">Estatus</span>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="form-control font-weight-bold"
                                                            disabled
                                                            readOnly
                                                            value={this.U_Status(Status || '')}
                                                        />
                                                    </div>

                                                    {/* Fecha aceptación */}
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                                <span className="d-none d-xl-inline">Fecha Aceptación</span>
                                                                <span className="d-inline d-xl-none">F. Aceptación</span>
                                                            </span>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            disabled
                                                            readOnly
                                                            value={AcceptDate ?? ''}
                                                        />
                                                    </div>
                                                </>
                                            )}

                                            {/* Tipo de operación */}
                                            {!isDetail &&
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                            <span className="d-none d-xl-inline">Tipo de operación</span>
                                                            <span className="d-inline d-xl-none">Tipo Operación</span>
                                                        </span>
                                                    </div>
                                                    <select
                                                        className="form-control"
                                                        value={ShiftType || ''}
                                                        disabled={isDetail && !isReassigned}
                                                        onChange={(e) =>
                                                            (!isDetail || isReassigned) &&
                                                            this.setKeyValue('ShiftType', e.target.value)
                                                        }
                                                    >
                                                        <option value="" disabled>Seleccione una opción</option>
                                                        <option value="O">Cortes Abiertos</option>
                                                        <option value="C">Cortes Cerrados</option>
                                                    </select>
                                                </div>
                                            }

                                            {/* Código usuario origen */}
                                            {isDetail && !isReassigned && (
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text font-weight-bold">
                                                            Código origen
                                                        </span>
                                                    </div>
                                                    <input type="text" className="form-control" disabled readOnly value={UsrOri || ''} />
                                                </div>
                                            )}

                                            {/* Usuario origen */}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                        <span className="d-none d-xl-inline">Usuario origen</span>
                                                        <span className="d-inline d-xl-none">Usuario origen</span>
                                                    </span>
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    disabled
                                                    readOnly
                                                    value={UsrOriName || UsrOri || ''}
                                                />
                                            </div>

                                        </div>

                                        {/* DERECHA */}
                                        <div className="col-12 col-md-6">

                                            {/* SOLO DETALLE */}
                                            {isDetail && <>
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                            <span className="d-none d-xl-inline">Fecha Registro</span>
                                                            <span className="d-inline d-xl-none">F. Registro</span>
                                                        </span>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        disabled
                                                        readOnly
                                                        value={CreateDate || ''}
                                                    />
                                                </div>
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                            <span className="d-none d-xl-inline">Tipo de corte</span>
                                                            <span className="d-inline d-xl-none">Tipo Corte</span>
                                                        </span>
                                                    </div>
                                                    <select
                                                        className="form-control"
                                                        value={ShiftType || ''}
                                                        disabled={isDetail && !isReassigned}
                                                        onChange={(e) =>
                                                            (!isDetail || (isDetail && isReassigned)) &&
                                                            this.setKeyValue('ShiftType', e.target.value)
                                                        }
                                                    >
                                                        <option value="" disabled>Seleccione una opción</option>
                                                        <option value="O">Cortes Abiertos</option>
                                                        <option value="C">Cortes Cerrados</option>
                                                    </select>
                                                </div>
                                            </>}


                                            {/* SIEMPRE */}
                                            {/* Código usuario destino */}
                                            {isDetail && !isReassigned && (
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text font-weight-bold">
                                                            Código destino
                                                        </span>
                                                    </div>
                                                    <input type="text" className="form-control" disabled readOnly value={UsrDes || ''} />
                                                </div>
                                            )}

                                            {/* Usuario destino */}
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text font-weight-bold" id="basic-addon1">
                                                        <span className="d-none d-xl-inline">Usuario destino</span>
                                                        <span className="d-inline d-xl-none">Usuario destino</span>
                                                    </span>
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    disabled
                                                    readOnly
                                                    value={isReassigned ? (UsrDes || '') : (UsrDesName || UsrDes || '')}
                                                />

                                                {((ShiftType && (!isDetail && !isReassigned)) || (ShiftType && (isDetail && isReassigned))) && (
                                                    <button
                                                        type="button"
                                                        style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                        className="input-group-text"
                                                        onClick={this.showUsers}
                                                    >
                                                        <i className="fa fa-list" />
                                                    </button>
                                                )}
                                            </div>

                                        </div>
                                    </div>

                                    <div className="row m-1 justify-content-around">
                                        <div className='col-12' style={{ height: 350, maxHeight: 450, overflow: 'auto' }}>
                                            <table id="cutTransferTable" className="display" style={{ width: '100%' }}>
                                                <thead className="table-header">
                                                    <tr>
                                                        {headers?.map((h, index) => (
                                                            <th
                                                                key={index}
                                                                className="sticky-header table-header-yellow text-center"
                                                                style={{ whiteSpace: 'nowrap' }}
                                                            >
                                                                {h.title}
                                                            </th>
                                                        ))}
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {operations?.map((row, index) => (
                                                        <tr key={index}>
                                                            {headers.map((h) => (
                                                                <td className='text-center' key={h.key} style={{ whiteSpace: 'nowrap' }}>
                                                                    {row[h.key]}
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="modal-footer">
                                <div className='row d-flex justify-content-center align-items-center'>

                                    <button type="button" className="btn botonCerrar text-white mb-1 mr-1" onClick={() => this.closeAction()}>Cerrar</button>
                                    {isReassigned &&
                                        <button type="button"
                                            className={`btn btn-outline-danger mr-1 mb-1`}
                                            onClick={this.cancellReassigned}
                                        >
                                            Cancelar

                                        </button>
                                    }

                                    {(Status === 'P' || Status === 'R') &&
                                        <>
                                            {isDetail && !isReassigned &&
                                                <button type="button"
                                                    className={`btn btn-outline-primary mr-1 mb-1`}
                                                    onClick={this.reassigned}
                                                >
                                                    Reasignar Corte

                                                </button>
                                            }
                                            <button type="button"
                                                className={`btn btn-${isDisabledTransfer ? 'dark' : 'warning'} mb-1`}
                                                disabled={isDisabledTransfer}
                                                onClick={() => (!isDisabledTransfer) && this.showConfirmModal(!isReassigned ? 1 : 2)}
                                            >
                                                Traspasar Corte

                                            </button>
                                        </>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {showCutTransferUsersModal &&
                    <CutTransferUsersModal
                        enableSpinner={enableSpinner}
                        showAlert={showAlert}
                        selectUser={this.selectUser}
                        cleanData={this.setKeyValue}
                        users={users}
                    />
                }

                {/* MODAL CONFIRMACIÓN */}
                <div className={`modal fade ${showConfirmModal ? 'show d-block' : ''}`} id="confirmCutTransferModal" tabIndex="-1" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirmación</h5>
                                <button type="button" className="close" onClick={this.hideConfirmModal}>
                                    <span>&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                {confirmText}
                            </div>

                            <div className="modal-footer">
                                <button className="btn btn-dark" onClick={this.hideConfirmModal}>
                                    Cancelar
                                </button>
                                <button className="btn btn-warning" onClick={this.confirmAction}>
                                    Confirmar
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CutTransferModal;